import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentLoSignupState {
  private suggestedDomains$ = new BehaviorSubject<Array<any>>([]);
  domain = this.suggestedDomains$.asObservable();
  public get domainValue(): Array<any> {
    return this.suggestedDomains$.value;
  }
  public set domainValue(data: Array<any>) {
    this.suggestedDomains$.next(data);
  }
}
